import type { ReactNode } from "react";
import { Link } from "react-router";
import { PageFooter } from "@noiman/ui/page-footer";
import type { PageHeaderLanguageOption } from "@noiman/ui/page-header";
import { AppPageHeader } from "@/components/common/AppPageHeader";
import { useAuth } from "@/contexts/auth.context";
import { useGlobalSearch } from "@/contexts/global-search.context";

/**
 * トップや /news と同じ公開ページのヘッダーとフッターで包む器。
 * 認証の layout の外に置くページで、ログイン無しで開ける。
 */
export function PublicPageShell({
  children,
  languages,
}: {
  children: ReactNode;
  /** その頁の言語の切り替え。訳が無い頁は渡さない (帯に何も出ない) */
  languages?: readonly PageHeaderLanguageOption[];
}) {
  const { user } = useAuth();
  const { openSearch } = useGlobalSearch();
  return (
    <div className="flex min-h-screen flex-col bg-main text-main">
      <AppPageHeader
        LinkComponent={Link}
        userEmail={user?.email}
        userName={user?.name}
        userLevel={user?.levelInfo?.level}
        userRank={user?.levelInfo?.rank}
        userTotalXp={user?.levelInfo?.totalXp}
        userXpToNextLevel={user?.levelInfo?.xpToNextLevel}
        onSearchClick={openSearch}
        languages={languages}
      />
      <main className="flex-1">{children}</main>
      <PageFooter LinkComponent={Link} />
    </div>
  );
}
